import React from "react";
//import ReactDOM from 'react-dom';
import axios from 'axios';
import "./Search.css";
import ReactLoading from 'react-loading';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SearchIcon from '@mui/icons-material/Search';
class Search extends React.Component {     
    constructor(props) {
        super(props);
        this.state = {
            cat : [],loading:'',menu:[],
            srch:[],view:false,searchContent:false
           

        }
        
    };       
    async searchResult(e, keyword){
        //alert(keyword.length)
        this.setState({srch:keyword})
        if (keyword.length > 2){
            
            this.setState({loading:<ReactLoading type="bars" color="#000" height={50} width={35} /> })
            axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.item_search?item=' + keyword,{
                headers : {'content-type': 'application/json'}
            })
            .then(response=>{
                this.setState({loading:''})
                this.setState({menu:response.data['message']})
                console.log(response.data['message'])
                this.setState({view:true})
                this.setState({searchContent:true})
            })
        }
        else{

            this.setState({menu:[]})
            this.setState({loading:''})
            this.setState({searchContent:false})
        }
        
      }

   
    render() {
        return <div className="col-md-10 d-flex pb-2 ">
        <div className="search-element media-body   float-right">
           <form className="d-flex search_box" action="#">
                
                <input type="text" className="src-hov" onChange={e => this.searchResult(e, e.target.value)} placeholder="Enter your search key ... " />
              {/*   <button >Search</button> */}
                <button ><a className="srch-color" href={'/search/'+this.state.srch}><SearchIcon/></a></button> 
                <div className={this.state.searchContent ? 'search_box_content d-block' : 'd-none'}    >
                            {this.state.loading}
                            {this.state.menu.map((itm,p)=>{
                                 if(p < 4){
                                return(<div className={"row row" + p}  onClick={(e) => {this.setState({searchContent:true})}}>
                                            <div className="col-md-2 float-left srch-width"><a href={ '/product-details/' + itm.item_code }><img alt={itm.item_name} src={( itm.website_image )? process.env.REACT_APP_API_URL +itm.website_image:'/assets/images/missing.jpg'} style={{maxHeight: 75}} width="50px"/></a></div>
                                            
                                            <div className="col-md-6 text-left  ml-2 my-auto float left none-width"><a href={  '/product-details/' + itm.item_code }><span className="my-auto srch-text srch-result-itm">{itm.item_name}</span></a></div>
                                            
                                               <div className="text-left  ml-5 my-auto"><a href={  '/product-details/' + itm.item_code }><span className="my-auto  pay-csh srch-result-itm rupay-font"> 
                                               ₹ {itm.price}</span></a></div> 
                                    </div>)
                                 }
                                 else
                                 return ""
                            })}  
                        {this.state.menu.length ?<div> <p className=" srch-result-align" type="button" ><a href={'/search/' + this.state.srch } className="float-left srch-result-clr">{this.state.menu.length} Results Found</a><a href={'/search/' + this.state.srch } className="float-right srch-result-clr">View All</a></p></div> : '' }            
          
                    </div>
                
        
             </form>
        </div>
</div>   
            }
              }
            export default Search;